export default __webpack_public_path__ + "static/media/task-manager.7cdcc29e.png";